import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getTalkingPointStatuses = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/briefs/talking-points/statuses' });

  return data;
};

export default getTalkingPointStatuses;
